import depth_frag from './shaders/depth_frag.glsl';
import depth_vert from './shaders/depth_vert.glsl';

/**
 * @module ShaderChunk
 */
const ShaderChunk = {
    depth_frag,
    depth_vert
};

export default ShaderChunk;
